import React from "react";
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

interface FrameworkBadgesProps {
  mappings: string;
  showAll: boolean;
  toggleShow: () => void;
}

export const FrameworkBadges: React.FC<FrameworkBadgesProps> = ({ 
  mappings, 
  showAll, 
  toggleShow 
}) => {
  if (!mappings || typeof mappings !== "string") return <span>--</span>;

  const frameworks = mappings.split(",");

  return (
    <>
      <span className="badge px-3 rounded-pill me-1" style={{ border: "2px solid #E1E1E1" }}>
        {frameworks[0].trim()}
      </span>

      {frameworks.length > 1 && !showAll && (
        <OverlayTrigger
          placement='right'
          popperConfig={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 8],
                },
              },
            ],
          }}
          overlay={
            <Tooltip id='tooltip-frameworks' style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>
              <span style={{fontSize:'12px', display: 'block', textAlign: 'left'}} className="fw-semibold">
              {frameworks.slice(1).map((framework, index) => (
                framework.trim()
              )).join('\n')}
              </span>
            </Tooltip>
          }
        >
          <button className="btn btn-icon btn-sm">
            <span
              className="badge px-3 rounded-pill"
              style={{ border: "2px solid #E1E1E1" }}
            >
              +{frameworks.length - 1}
            </span>
          </button>
        </OverlayTrigger>
      )}

      {showAll && frameworks.slice(1).map((framework, idx) => (
        <div key={idx} className="d-flex flex-stack my-1">
          <span className="text-muted fw-semibold">
            <span className="badge px-3 rounded-pill" style={{ border: "2px solid #E1E1E1" }}>
              {framework.trim()}
            </span>
          </span>
        </div>
      ))}
    </>
  );
};